import { Reveal } from "./Reveal";
import { Eyebrow } from "./Shared";
import { PhotoSlot } from "./PhotoSlot";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="scroll-mt-20">
      <div className="grid lg:grid-cols-2">
        <div className="order-2 flex items-center justify-center bg-navy p-10 lg:order-1 lg:p-20">
          <Reveal className="w-full max-w-md">
            <PhotoSlot slotId="IMG_ABOUT" aspect="aspect-[4/5]" className="w-full" />
          </Reveal>
        </div>
        <div className="order-1 bg-brand-n2 px-6 py-16 text-navy sm:px-12 lg:order-2 lg:px-20 lg:py-28">
          <Reveal>
            <Eyebrow>About</Eyebrow>
            <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] sm:text-4xl lg:text-5xl">
              Raised in compliance.{" "}
              <span className="text-brand-orange">Building the fintech super app.</span>
            </h2>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-navy/80 sm:text-lg">
              <p>
                Emmanuel Quezada was born in Mexico on the 3rd of March, 1997. The useful part
                of the story starts earlier than the founding date. His father, Javier Quezada,
                spent decades running ATS Group: compliance, digital ledgers, the unglamorous
                work governments actually pay for. At fifteen Emmanuel was not handed a
                motivational book. He was handed a company.
              </p>
              <p>
                That is the difference. He does not romanticize entrepreneurship. He was trained
                inside it: budgets, people, reporting, the quiet discipline of showing up on the
                tenth with the books clean.
              </p>
              <p>
                He led a seventy-person production of the film <em>Polyglot</em>. He studied
                applied blockchain in Gold Coast, Australia, while running ATS Corporate. In
                October 2021 he founded u-topia, first as a way to make digital ownership
                legible to ordinary people, including the next generation, and then as something
                more ambitious: a unified financial ecosystem that takes the best of traditional
                finance and the best of open rails and refuses to make users choose.
              </p>
              <p>
                He speaks Spanish, English, French, and Italian. He has lived the work in Dubai
                and Ras Al Khaimah and is now based in Bangkok. The through-line is not a
                passport stamp. It is a question he will not put down:{" "}
                <strong className="font-semibold text-navy">
                  what would money look like if it were designed for the person holding the
                  phone?
                </strong>
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="bg-navy px-6 py-20 lg:py-28">
        <Reveal className="mx-auto max-w-4xl text-center">
          <blockquote data-testid="about-pull-quote">
            <p className="text-2xl font-medium leading-snug tracking-[-0.01em] text-brand-orange sm:text-3xl lg:text-4xl">
              “The world does not need another app that talks about freedom. It needs rails
              people can actually use, and a school that teaches them how.”
            </p>
            <footer className="mt-6 text-[12px] font-semibold uppercase tracking-[0.2em] text-white/50">
              Emmanuel Quezada
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
